

const toggleSort = type => {
  const types = { asc: 'desc', desc: 'asc' };
  return types[type];
};

export {
  toggleSort
}